import api from "./axios/config";

export async function signIn(payload) {
  try {
    const { data } = await api.post('auth/signin', payload);

    return { success: true, data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function signUp(payload) {
  try {    
    const { data } = await api.post('auth/signup', payload);

    return { success: true, data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function fetchUsers() {
  try {
    const { data } = await api.get('users');

    return { success: true, data: data.data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function logout() {
  try {
    await api.post('auth/logout');

    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');

    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
}

export async function fetchUser() {
  try {
    const { data } = await api.get('auth/user');

    return { success: true, data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function updateAccess(id, access) {
  try {
    await api.put(`users/${id}/access`, { access });

    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
}

export async function createUser(payload) {
  try {
    const { data } = await api.post('users', payload);

    return { success: true, user: data };
  } catch (error) {
    return { success: false, error };
  }
}

export async function updateUser(payload) {
  try {
    await api.patch(`users/${payload.id}`, payload);

    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
}